import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FormApiService} from '@app/core/services/form-api.service';
import {MeteringPointService} from '@app/api/dmc';
import {InputDirective} from '@shared/components/input/input/input.directive';
import {InputGroupComponent} from '@shared/components/input/input-group/input-group.component';
import {LabelDirective} from '@shared/components/input/label/label.directive';
import {TranslatePipe} from '@ngx-translate/core';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-query-masterdata-charge',
  imports: [
    FormsModule,
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './query-masterdata-charge.component.html',
  styleUrl: './query-masterdata-charge.component.css'
})
export class QueryMasterdataChargeComponent implements OnInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    start: new FormControl(null, Validators.required),
    end: new FormControl(null),
  })

  public identification?: string;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
  ) {

  }

  ngOnInit(): void {
    if (this.identification) {
      this.form.get('meteringPointIdentification')?.setValue(this.identification);
    }
  }

  public requestMasterData(): void {
    if (this.form.valid) {
      // Handle start date (required)
      this.form.get('start')?.setValue(new Date(this.form.get('start')?.value).toISOString().split('T')[0]);

      // Handle end date (optional) - only convert if it has a value
      const endValue = this.form.get('end')?.value;
      if (endValue) {
        this.form.get('end')?.setValue(new Date(endValue).toISOString().split('T')[0]);
      }

      this.formApiService.submit(
        this.form,
        (data) => this.meteringPointService.meteringPointQueryMasterDataChargePost(data),
        {
          successMessage: 'meteringpoint.pricing.requestMasterDataChargeSuccesful',
          closeModal: true,
        }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }
}
